<template>
    <div class="toggle-button-group">
      <button
        v-for="(button, index) in buttons"
        :key="index"
        :class="{ active: activeButton === button.value }"
        @click="handleClick(button.value)"
      >
        {{button.label}}
        <span v-if="button.count !== undefined && button.count !== null" class="badge" :class="{ 'badge-active': activeButton === button.value }">
          {{ button.count }}
        </span>
      </button>
    </div>
  </template>

  <script>
  export default {
    name: 'ToggleButtonGroup',
    props: {
      buttons: {
        type: Array,
        required: true,
        validator: (value) => value.every(button => button.value && button.label)
      },
      activeButton: {
        type: String,
        required: true
      },
      handleClick: {
        type: Function,
        required: true
      }
    }
  }
  </script>

<style scoped>
 .toggle-button-group {
  display: flex;
  border-radius: 0.25rem;
  width: fit-content;
  /* flex-wrap: wrap; */
  border:1px solid rgba(201, 192, 192, 0.4);
  border-radius: 0.25rem;
}
.toggle-button-group button:first-child {
border-radius: .25rem 0 0 .25rem;
border:none;
}
.toggle-button-group button:last-child {
  border-radius: 0 .25rem .25rem 0;
border:none;
}
.toggle-button-group button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  padding: 6px 16px;
  cursor: pointer;
  outline: none;
  background:white;
  border-left:1px solid rgba(201, 192, 192, .4);
  border-right: 1px solid rgba(201, 192, 192, .4);
}

.toggle-button-group button.active {
  background-color: #f7941e;
  color: white;
  border:1px solid transparent;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background-color: #e5e7eb;
  color: #374151;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1;
  vertical-align: middle;
  margin-top: -1px;
}

.badge-active {
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
}
</style>
